import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllMonitorErrors } from "@/api/monitor";
import { MonitorQueryKeys } from "@/tanstackQuery/queries/monitor";

export const useDeleteAllMonitorErrors = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteAllMonitorErrors(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MonitorQueryKeys.ErrorsPaginated] });
      queryClient.invalidateQueries({ queryKey: [MonitorQueryKeys.ErrorDetail] });
    },
  });
};
